
import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface IGetSiteEncryptionSingleKeyHistoryParams {
  keyId: string;
}

export interface IGetSiteEncryptionSingleKeyHistoryEvent {
  eventDate: string;
  keyId: string;
  keyVersion: number;
  username: string;
  postActionKeyStatus: string;
  description: string;
  actionStatus: string;
  actionType: string;
}

export interface GetSiteEncryptionSingleKeyHistoryResult extends IResult {
  events: IGetSiteEncryptionSingleKeyHistoryEvent[];
}

export class GetSiteEncryptionSingleKeyHistoryRequest extends Request<IGetSiteEncryptionSingleKeyHistoryParams, GetSiteEncryptionSingleKeyHistoryResult> {
  constructor(params: IGetSiteEncryptionSingleKeyHistoryParams) {
    super('getSiteEncryptionSingleKeyHistory', params);
  }
}